module.exports = __webpack_public_path__ + "img/tree_left_layout_icon.3d9c72ce.svg";